import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { NextUIProvider } from '@nextui-org/react'
import { BrowserRouter } from 'react-router-dom'

import './index.css';
import App from './App';
import store from './store'
import theme from './ui/theme'

ReactDOM.render(
  <Provider store={store}>
    <NextUIProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
    </NextUIProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
